module.exports = __webpack_public_path__ + "static/5csm_tray_naslovna-5b043fbe02f09fbac1f6ce1de4b9e75b.jpg";